import { useWindowSize } from "@/hooks";
import { ElementService } from "@/services/user-services";
import { useLocaleStore } from "@/stores";
import { useEffect, useLayoutEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

const Unsubscribe = () => {
    const activeRegion = useLocaleStore((state) => state.activeRegion);
    const activeLanguage = useLocaleStore((state) => state.activeLanguage);

    const [width] = useWindowSize();
    const [left, setLeft] = useState(0);

    const { identifier } = useParams();

    const elementService = useMemo(
        () => new ElementService(activeRegion!, activeLanguage!),
        [activeRegion, activeLanguage]
    );

    const { t } = useTranslation("common");

    useEffect(() => {
        if (!identifier) return;
        elementService.unsubscribe(identifier);
    }, [elementService, identifier]);

    useLayoutEffect(() => {
        if (width === 2560) {
            setLeft(0);
        } else {
            const change = 2560 - width;
            setLeft(change * -0.5);
        }
    }, [width]);

    return (
        <>
            <div
                className={`absolute w-full h-full bg-primary-100 overflow-hidden`}
                style={{
                    left: `${left}px`,
                    width: 2015,
                    clipPath: "polygon(200px 0, 2015px 0, 838px 350px)",
                }}
            />

            <div className="container mx-auto 2xl:px-[108px]">
                <section id="hero" className="relative pt-[60px] mb-1">
                    <div className="mt-10">
                        <h1 className="flex content-center gap-3 items-center">
                            <span className="text-primary-500">{t("unsubscribe.title")}</span>
                        </h1>
                    </div>
                </section>
                <main className="pb-[160px]">
                    <div className="relative grid grid-cols-[1fr] gap-13 gap-y-50 mt-36">
                        <div>
                            <p className="font-medium">{t("unsubscribe.description")}</p>
                        </div>
                    </div>
                </main>
            </div>
        </>
    );
};

export default Unsubscribe;
